var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"version2-bottom-block"},[_c('leftBlock'),_c('middleBlock'),_c('rightMiddle')],1)}
var staticRenderFns = []

export { render, staticRenderFns }